import React from "react";

const ContactBanner = () => {
  return (
    <div className="container-fluid contact-banner">
      <div className="contact-banner-content">
        <h2>
          LET’S START YOUR INTERNATIONAL <br /> CERTIFICATION JOURNEY TODAY
        </h2>
        <p>
          Our team is here to answer your questions and guide you through every <br />
          step of your ISO certification journey.
        </p>
        <button
          className="btn btn-outline-light rounded-pill px-4 mt-3"
        >
           Get started
        </button>
      </div>
    </div>
  );
};

export default ContactBanner;
